<template>
  <v-dialog
    :value="activator"
    :max-width="maxWidth"
    scrollable
    @input="$emit('closeModal')"
  >
    <v-card>
      <v-card-title v-if="title" class="headline accent--text py-4 pb-0">
        {{ title }}
      </v-card-title>

      <v-card-subtitle v-if="subtitle" v-html="subtitle" class="pb-0 pt-2" />

      <v-card-text outlined tile class="pt-6">
          <slot name="content" />
      </v-card-text>

      <v-card-actions class="px-6 pb-4 pt-0">
        <slot name="modal-footer"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogModal',

  props: {
    title: String,
    subtitle: String,
    activator: Boolean,
    maxWidth: {
      type: Number,
      default: 600
    }
  }
}
</script>
